import { IPolygon } from "../Models/IPolygon";

export const isMobilyticsPlace = (bucketType: number) => {
    return (
        bucketType
      === (window as any).scout.models.DataBucketTypeEnum.MOBILYTICS_PLACE
    || bucketType
      === (window as any).scout.models.DataBucketTypeEnum.MOBILYTICS_PLACE_GEOFENCE
    );
};

export const polygonsAreIdentical = (polygons: IPolygon[]): boolean => {
    if (!polygons || polygons?.length === 0) {
        return false;
    }

    const polyLengths = polygons.map((polygon) => polygon.linearRings[0].length);
    const allSameLength: boolean = polyLengths.every(
        (length) => (length = polyLengths[0])
    );

    if (!allSameLength) {
        return false;
    }

    const comparisonPolygon: IPolygon = polygons[0];
    const polyLength: number = polyLengths[0];

    for (let i = 0; i < polyLength; i++) {
        const comparisonPoint = comparisonPolygon.linearRings[0][i];

        const identicalX = polygons.every((polygon) => {
            const pointInThisPoly = polygon.linearRings[0][i];
            return pointInThisPoly.x === comparisonPoint.x;
        });
        const identicalY = polygons.every((polygon) => {
            const pointInThisPoly = polygon.linearRings[0][i];
            return pointInThisPoly.y === comparisonPoint.y;
        });

        if (!(identicalX && identicalY)) {
            return false;
        }
    }

    return true;
};
